import { doesNativeConnectorExist, nativeDownloadProductPictures } from './NativeConnector';

export const downloadPictures = ({ productIds }) => {
  if (doesNativeConnectorExist()) {
    nativeDownloadProductPictures({ productIds });
  }
};
